import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Input } from '../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makePutRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'

export default function EditOperationForm({ setOperations, params, operations, setSelected }) {
  const [open, setOpen] = useState(true)

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      id: params[0].id,
      Name: params[0].Name,
    },
  })

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePutRequest(
      urls.crudRecettesCategoryOperations + `${data.id}/`,
      payload,
      {},
      true,
    )

    if (response.status === 200) {
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))

      handleClose()
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Modifier catégorie de recettes</DialogTitle>

        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Name"
              label="Name"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
